module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Bold.309d8252.eot";